// Cell HTML can come from community-shared templates, so it is untrusted.
// Parsed with DOMParser (inert: no scripts run, no images load), then rebuilt from an allowlist.
const ALLOWED_TAGS = new Set([
  "A", "B", "STRONG", "I", "EM", "U", "S", "STRIKE", "BR", "SPAN", "DIV", "P",
  "SUB", "SUP", "UL", "OL", "LI", "FONT",
]);
const DROP_WITH_CONTENT = new Set([
  "SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "SVG", "MATH", "TEMPLATE", "NOSCRIPT", "LINK", "META",
]);
const SAFE_HREF = /^(https?:|mailto:|tel:)/i;
const UNSAFE_STYLE = /url\s*\(|expression|javascript:|behavior|@import|-moz-binding/i;

function cleanStyle(value) {
  return String(value || "")
    .split(";")
    .map((part) => part.trim())
    .filter((part) => part && !UNSAFE_STYLE.test(part))
    .join("; ");
}

function cleanNode(source, target, doc) {
  Array.from(source.childNodes).forEach((child) => {
    if (child.nodeType === 3) {
      target.appendChild(doc.createTextNode(child.nodeValue));
      return;
    }
    if (child.nodeType !== 1) return;
    const tag = child.tagName.toUpperCase();
    if (DROP_WITH_CONTENT.has(tag)) return;
    if (!ALLOWED_TAGS.has(tag)) {
      cleanNode(child, target, doc);
      return;
    }
    const copy = doc.createElement(tag.toLowerCase());
    const style = cleanStyle(child.getAttribute("style"));
    if (style) copy.setAttribute("style", style);
    if (tag === "A") {
      const href = (child.getAttribute("href") || "").trim();
      if (SAFE_HREF.test(href)) {
        copy.setAttribute("href", href);
        copy.setAttribute("rel", "noopener noreferrer");
        copy.setAttribute("target", "_blank");
      }
    }
    cleanNode(child, copy, doc);
    target.appendChild(copy);
  });
}

export function sanitizeCellHtml(html) {
  const input = String(html ?? "");
  if (!input || (!input.includes("<") && !input.includes("&"))) return input;
  if (typeof DOMParser === "undefined") return input.replace(/[<>]/g, "");
  const doc = new DOMParser().parseFromString(`<body>${input}</body>`, "text/html");
  const out = doc.createElement("div");
  cleanNode(doc.body, out, doc);
  return out.innerHTML;
}
